<template>
  <div class="side-bar">
    <v-navigation-drawer
      permanent
      class="nav-drawer"
      style="border-radius: 7px; box-shadow: 1px 1px 1px rgba(17, 58, 34, 0.07)"
    >
      <!-- For super admin  -->
      <v-list v-if="isSuperadmin" class="superadmintabs" nav dense>
        <v-list-item
          :disabled="item.underDevelopment"
          v-for="(item, index) in superadminItems"
          :key="index"
          :to="{ name: item.pathName }"
          active-class="side-bar-active"
          link
        >
          <v-list-item-icon>
            <v-icon color="#919191" class="nav-icon">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list nav dense>
        <v-list-item
          :disabled="item.underDevelopment"
          v-for="(item, index) in items"
          :key="index"
          :to="{ name: item.pathName }"
          active-class="side-bar-active"
          link
        >
          <v-list-item-icon>
            <v-icon color="#919191" class="nav-icon">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-list nav>
          <v-list-item
            v-for="(item, index) in appendedItems"
            :key="index"
            @click="checkAction(item.method)"
            link
          >
            <v-list-item-icon>
              <v-icon color="#919191">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import accessToken from "../../../helpers/accessToken";
import apiEndpoints from "@/helpers/apiUrls";
import methods from "../../../helpers/methods";
//import API_URL from '../../../helpers/apiUrls'
export default {
  name: "sideBar",

  data() {
    return {
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          pathName: "dashboard",
          underDevelopment: false,
        },
        {
          title: "My Farmers",
          icon: "mdi-image",
          pathName: "myFarmers",
          underDevelopment: false,
        },
        {
          title: "Create Content",
          icon: "mdi-rocket",
          pathName: "createContent",
          underDevelopment: false,
        },
        {
          title: "Messages",
          icon: "mdi-message-minus-outline",
          pathName: "messages",
          underDevelopment: true,
        },
        {
          title: "Query",
          icon: "mdi-chat-question",
          pathName: "query",
          underDevelopment: false,
        },
        {
          title: "Market intelligence",
          icon: "mdi-earth",
          pathName: "market-intelligence",
          underDevelopment: false,
        },
        {
          title: "Active Inquiries",
          icon: "mdi-link",
          pathName: "activeLeads",
          underDevelopment: false,
        },
        {
          title: "Retailers",
          icon: "mdi-satellite-uplink",
          pathName: "retailers",
          underDevelopment: true,
        },
        {
          title: "Products",
          icon: "mdi-gift",
          pathName: "products",
          underDevelopment: false,
        },
        // { title: 'Business List', icon: 'mdi-domain', pathName : 'adminpanel', underDevelopment : false},
        // { title: 'Home', icon: 'mdi-home', pathName : 'home', underDevelopment : false},
      ],

      superadminItems: [
        {
          title: "Business List",
          icon: "mdi-domain",
          pathName: "adminpanel",
          underDevelopment: false,
        },
        {
          title: "Home",
          icon: "mdi-home",
          pathName: "home",
          underDevelopment: false,
        },
      ],

      appendedItems: [
        // { title: 'Need help?', icon: 'mdi-view-dashboard', method : '' },
        {
          title: "Settings",
          icon: "mdi-cog-outline",
          method: "settings",
        },
        {
          title: "Logout",
          icon: "mdi-account-arrow-left",
          method: "logout",
        },
      ],
      isSuperadmin: false,
    };
  },

  created() {
    this.getSideBarItems();
  },

  methods: {
    getSideBarItems() {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("ADD COMMENT RES ", response.data);
          this.isSuperadmin = response.data.is_super_admin;
          // alert(isSuperadmin)
          this.$store.dispatch(
            "mainStore/setSuperAdmin",
            response.data.is_super_admin
          );
          if (process.env.VUE_APP_MOENGAGE_ACTIVE !== "false") {
            window?.Moengage.destroy_session();
          }
        }

        // console.log(response.data);
        // setTimeout(() => {
        if (process.env.VUE_APP_MOENGAGE_ACTIVE !== "false") {
          //
          const id = response.data.is_super_admin
            ? localStorage.getItem("Super-ID")
            : localStorage.getItem("Brand-ID");
          response.data.is_super_admin
            ? window?.Moengage.add_unique_user_id(
                localStorage.getItem("Super-ID")
              )
            : window?.Moengage.add_unique_user_id(
                localStorage.getItem("Brand-ID")
              );
          window?.Moengage.add_first_name(localStorage.getItem("UserName"));
          this.getAndSetEmailMoengage(id);
        }
        //}, 1000);
      };

      const errorHandler = (error) => {
        console.log(error.data);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };

      this.requestGET(
        apiEndpoints.sidebar,
        {},
        headers,
        successHandler,
        errorHandler
      );
    },

    checkAction(method) {
      if (method === "logout") this.logout();
      else if (method === "settings")
        this.$router.push({ name: "profileSettings" });
    },

    logout() {
      // window?.Moengage.destroy_session();
      this.$store.dispatch("mainStore/logoutUser");
    },

    getAndSetEmailMoengage(id) {
      // if (this.$store.getters["mainStore/GET_SUPER_ADMIN"] == true) {
      //   window?.Moengage.add_unique_user_id(localStorage.getItem("Super-ID"));
      //   // localStorage.setItem('Super-ID',localStorage.getItem("Brand-ID"))
      // } else {
      //   window?.Moengage.add_unique_user_id(localStorage.getItem("Brand-ID"));
      // }
      //alert('this.$store.getters["mainStore/GET_SUPER_ADMIN"]')
      // window?.Moengage.add_first_name(localStorage.getItem("UserName"));
      const successHandler = (response) => {
        if (response.status === 200) {
          if (response.data.email)
            window?.Moengage.add_email(response.data.email);
            setTimeout(() => {
              methods.generateClevertapUserEvent(
            localStorage.getItem("UserName"),
            id,
            response.data.email
          );
            }, 1000);
            
        }
      };

      const errorHandler = (error) => {
        console.log(error);
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };

      this.requestGET(
        apiEndpoints.getEmail +
          `?business_id=${
            this.$store.getters["mainStore/GET_SUPER_ADMIN"]
              ? localStorage.getItem("Super-ID")
              : localStorage.getItem("Brand-ID")
          }`,
        {},
        headers,
        successHandler,
        errorHandler
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-drawer {
  font-family: Roboto;
  height: calc(100vh - 110px) !important;
}

.side-bar-active {
  background: linear-gradient(
    90deg,
    rgba(65, 151, 108, 0.11),
    rgba(255, 255, 255, 0)
  );
  color: var(--primary-color);
  border-radius: 2px;
  border-left: 3px solid var(--primary-color);
  font-weight: 500;

  .nav-icon {
    color: var(--primary-color) !important;
  }
}
.superadmintabs {
  border-bottom: 0.5px solid #333333;
  // border-radius: 10px;
}
@media all and (min-width: 1000px) {
  .side-bar {
    padding-right: 15px;
  }
}
</style>

<style lang="scss">
.nav-drawer .v-list--nav {
  padding-right: 0;
  padding-left: 0;
}
</style>
